import { doc, getDoc, getFirestore } from "firebase/firestore";
import { useQuery, useQueryClient } from "react-query";
import { convertLessonAlternativeLinkSnapToILessonAlternativeLink } from "../../types/firestoreMappings";
import { collectionPaths } from "../collectionPaths";
import { settledLogger } from "../settledLogger";

export const getLessonAlternativeLinkQueryKey = (
  lessonAlternativeLinkId: string
) => ["getLessonAlternativeLinkQueryKey", lessonAlternativeLinkId];

interface IGetLessonAlternativeLinkArgs {
  lessonAlternativeLinkId: string;
}

const getLessonAlternativeLink = async (
  vars: IGetLessonAlternativeLinkArgs
) => {
  const { lessonAlternativeLinkId } = vars;
  const db = getFirestore();
  const lessonAlternativeLinkDocRef = doc(
    db,
    collectionPaths.lessonAlternativeLinks,
    lessonAlternativeLinkId
  );
  const snapshot = await getDoc(lessonAlternativeLinkDocRef);
  if (snapshot.exists()) {
    return convertLessonAlternativeLinkSnapToILessonAlternativeLink(
      lessonAlternativeLinkId,
      snapshot.data()
    );
  } else {
    return Promise.reject(
      "getLessonAlternativeLink, lessonAlternativeLinkId not found"
    );
  }
};

export const useGetLessonAlternativeLinkQuery = (
  vars: IGetLessonAlternativeLinkArgs,
  enabled: boolean = true
) => {
  const { lessonAlternativeLinkId } = vars;
  return useQuery(
    getLessonAlternativeLinkQueryKey(lessonAlternativeLinkId),
    () => getLessonAlternativeLink(vars),
    {
      onSettled: settledLogger("useGetLessonAlternativeLinkQuery"),
      enabled,
    }
  );
};

export const useGetLessonAlternativeLinkFetch = () => {
  const queryClient = useQueryClient();
  return (vars: IGetLessonAlternativeLinkArgs) => {
    const { lessonAlternativeLinkId } = vars;
    return queryClient.fetchQuery(
      getLessonAlternativeLinkQueryKey(lessonAlternativeLinkId),
      () => getLessonAlternativeLink(vars)
    );
  };
};
